import { Dispatch, SetStateAction, useEffect } from "react";

export const useAutoCloseByStatus = (
  status: string | null,
  setStatus: Dispatch<SetStateAction<"success" | "error" | null>>,
  onClose: (e: React.MouseEvent<HTMLDivElement>) => void
) => {
  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (status === "success") {
      timer = setTimeout(() => {
        onClose({} as React.MouseEvent<HTMLDivElement>);
      }, 2000);
    } else if (status === "error") {
      timer = setTimeout(() => {
        setStatus(null);
      }, 3000);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [status, onClose, setStatus]);
};

export const useAutoResetStatus = (
  status: string | null,
  setStatus: Dispatch<SetStateAction<"success" | "error" | null>>,
  timeout: number = 3000
) => {
  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (status === "success" || status === "error") {
      timer = setTimeout(() => {
        setStatus(null);
      }, timeout);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [status, setStatus, timeout]);
};
